"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedOnChange = void 0;

var _toolbar = require("../constants/toolbar");

var debounceTimeout = null;
/**
 * Returns a debounced `handleInputChange` and non-debounced `handleStepChange`.
 * This hook is targeted for components rendering `UIStepperInput`.
 */

var useDebouncedOnChange = function useDebouncedOnChange(onChange) {
  var handleInputChange = function handleInputChange() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(function () {
      onChange.apply(void 0, args);
    }, _toolbar.DEBOUNCE_TIMEOUT);
  };

  var handleStepChange = function handleStepChange() {
    clearTimeout(debounceTimeout);
    onChange.apply(void 0, arguments);
  };

  return [handleInputChange, handleStepChange];
};

exports.useDebouncedOnChange = useDebouncedOnChange;